import PropTypes from 'prop-types'
import React from 'react'
// page imports
import Article from './pages/article'
import Home from './pages/home'

// page mappings
const pageComponentMapping = {
  article: Article,
  home: Home,
}

const Page = ({ pageProps }) => {
  const { pageName } = pageProps
  const PageComponent = pageComponentMapping[pageName]

  if (typeof PageComponent === 'function') {
    return (
      <div className="container">
        <PageComponent />
      </div>
    )
  }

  // TODO:: Track error FPTI in here
  return <div />
}

Page.propTypes = {
  pageProps: PropTypes.object.isRequired,
}
export default Page
